import React, { useEffect, useState } from 'react';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { Cross1Icon } from '@radix-ui/react-icons';
import PropTypes from 'prop-types';
import './SupportModal.scss';
import { getDesktopAppInstallLink } from '../../utils/desktop';

const Content = ({ children, ...props }) => (
    <AlertDialogPrimitive.Portal>
        <AlertDialogPrimitive.Overlay className={'SupportModal--styledOverlay'} />
        <AlertDialogPrimitive.Content className={'SupportModal--styledContent'} {...props}>
            {children}
        </AlertDialogPrimitive.Content>
    </AlertDialogPrimitive.Portal>
);
Content.defaultProps = {
    children: null
};
Content.propTypes = {
    children: PropTypes.node
};

const AlertDialog = AlertDialogPrimitive.Root;
const AlertDialogTrigger = AlertDialogPrimitive.Trigger;
const AlertDialogContent = Content;
const AlertDialogCancel = AlertDialogPrimitive.Cancel;

const SupportModal = () => {

    const [link, setLink] = useState('https://speedlabel-desktop-app.s3.amazonaws.com/SPEEDsnip+Setup+0.2.4.exe');
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!loaded) {
            (async () => {
                setLink(await getDesktopAppInstallLink());
                setLoaded(true);
            })();
        }
    }, []);

    return (

        <AlertDialog>
            <AlertDialogTrigger asChild>
                <button className={'SupportModal--cta'}>Support</button>
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogPrimitive.Title>
                    <div className={'SupportModal--buttonContainer'}>
                        <p className={'subtext'}>Support</p>
                        <AlertDialogCancel>
                            <button className={'SupportModal--cta'} variant="mauve" css={{ marginRight: 25 }}>
                                <Cross1Icon />
                            </button>
                        </AlertDialogCancel>
                    </div>
                </AlertDialogPrimitive.Title>
                <AlertDialogPrimitive.Description className={'SupportModal--description'}>
                    <>
                        <div>
                            <h4>Contact Us</h4>
                            <p>Feel free to reach out and contact us with any questions.</p>
                            <p>
                                <br />Email : <a href="mailto: support@fifthgeartech.com">support@fifthgeartech.com</a>
                                <br />Phone : (919) 676-2244
                            </p>
                        </div>

                        <div>
                            <p>
                                Do you want to lead the charge and start snipping immediately? The latest version of SPEEDsnip is just a click away!
                            </p>
                            <a href={link} target="_blank" rel="noreferrer">Download the latest SpeedSnip now.</a>
                        </div>

                        <div>
                            <p>
                                To screen-share an issue or watch a live demo on our screen, simply download the free TeamViewer app and contact our support staff.
                            </p>
                            <a href="https://get.teamviewer.com/ejc8zzm" target="_blank" rel="noreferrer">Download Teamviewer Software for Free.</a>
                        </div>

                        <div>
                            <p>To schedule an appointment with our support team, please click a date and time that works for you.</p>
                            <a href="https://calendly.com/yoshi-fifthgeartech-speedlabel/check-in-15-min-meeting" target="_blank" rel="noreferrer">Select a Date &amp; Time for an Appointment.</a>
                        </div>

                        <div>
                            <p>To learn more about SPEEDlabel and it&#39;s functionality, please visit our learning center for comprehensive video tutorials.</p>
                            <a href="https://speedlabel.net/learning-center/" target="_blank" rel="noreferrer">Explore our Video Tutorials.</a>
                        </div>
                    </>
                </AlertDialogPrimitive.Description>
            </AlertDialogContent>
        </AlertDialog>
    );

};

export default SupportModal;
